import React from "react";
import { Button } from "@/components/ui/button";
import { FileCheck, Eye } from "lucide-react";

export function VerificationsTab({ pendingVerifications, onViewDocuments }) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Pending Partner Verifications</h2>
      
      {pendingVerifications.length === 0 ? (
        <div className="text-center py-10 border border-border">
          <FileCheck className="w-12 h-12 mx-auto text-green-500 mb-4" />
          <p className="text-muted-foreground">No pending verifications</p>
        </div>
      ) : (
        <div className="space-y-3">
          {pendingVerifications.map((partner) => (
            <VerificationCard
              key={partner.partner_id}
              partner={partner}
              onViewDocuments={onViewDocuments}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function VerificationCard({ partner, onViewDocuments }) {
  return (
    <div className="border border-border p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-bold">{partner.partner_name}</p>
          <p className="text-sm text-muted-foreground">{partner.partner_email}</p>
          <p className="text-sm text-muted-foreground mt-1">
            {partner.documents.length} document(s) pending review
          </p>
        </div>
        <Button
          onClick={() => onViewDocuments(partner.partner_id)}
          className="rounded-none"
          data-testid={`view-docs-${partner.partner_id}`}
        >
          <Eye className="w-4 h-4 mr-2" />
          Review Documents
        </Button>
      </div>
    </div>
  );
}
